import {FETCHED_IMAGE_RATIOS} from "./types";

export function fetchedImageRatios(response) {
    return {
        type: FETCHED_IMAGE_RATIOS,
        payload: {
            ratios: response
        }
    };
}


// WEBPACK FOOTER //
// ./src/containers/images/actions.js